import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Flex, HighlightText, Icon, Link, Text, Tooltip } from "@driftt/dds"

import { useAppSelector } from 'hooks/useRedux'
import { Activity,AIScoringTopActivities } from "modules/accountActivity/domain"
import { userActivityTypeToPreviewSnippet } from "utils/activity"
import { timeSinceUpdated } from "utils/timeStamp"

const ActivityInfo = ({
    activity,
    topActivities = []
  }: {
    activity?: Activity
    topActivities?: AIScoringTopActivities[]
  }) => {
    const { id } = activity || {}
    const orgUsersById = useAppSelector(({ orgUsersById }) => orgUsersById.users)
  
    if (!activity) {
      return null
    }
  
    const isHightIntent = !!topActivities?.find(
      (a: AIScoringTopActivities) => a?.activityId === id && a.intent
    )
  
    const { action, preview, icon, suffix, href } = userActivityTypeToPreviewSnippet(activity, orgUsersById)
  
    return (
      <Flex alignItems="center" gap="half" fullWidth>
        <Icon icon={icon} size="medium" />
        {isHightIntent && (
          <Text css={{ minWidth: '80px' }}>
            <HighlightText color="purple">High Intent</HighlightText>
          </Text>
        )}
        <Link
          as={RouterLink}
          css={{
            maxWidth: '165px',
            textOverflow: 'ellipsis',
            color: '$blue8',
            '&:hover': {
              color: '$blue8',
              textDecoration: 'underline'
            }
          }}
          variant="object"
          truncate
          to={`/activity/contacts/${activity.endUserId}`}
          target="_blank">
          {activity.endUserData?.name || activity.endUserData?.email || 'Site visitor'}
        </Link>
  
        <Text variant="body" css={{ minWidth: 'max-content' }}>{action}</Text>
        {preview && (
          <Tooltip content={preview}>
            <Flex alignItems="center" gap={0}>
              &quot;
              <Box
                css={{
                  maxWidth: '200px',
                  overflow: 'hidden'
                }}>
                {href ? (
                  <Link truncate external href={href} css={{ textDecoration: 'underline' }}>
                    {preview}
                  </Link>
                ) : (
                  <Text truncate variant="metadata">
                    {preview}
                  </Text>
                )}
              </Box>
              &quot;
            </Flex>
          </Tooltip>
        )}
        <Flex alignItems="center" gap="half">
          {suffix && (
            <Text css={{ minWidth: 'max-content' }} variant="body">
              {suffix}
            </Text>
          )}
          <Text css={{ width: 'max-content' }} variant="body">
            {timeSinceUpdated(activity.createdAt)} ago
          </Text>
        </Flex>
      </Flex>
    )
  }

  export default ActivityInfo